// GDPR data controller for the honest-build legal page.
// Do not invent a company, address, registration number, or VAT ID —
// replace the remaining TODOs with real values only.
// contactEmail is the public support inbox.

export const DATA_CONTROLLER = {
  name: "Sportyshop Sports Marketing",
  streetAddress: "Beedstrasse 54",
  postalCode: "40468",
  city: "Düsseldorf",
  country: "Germany",
  // TODO: company registration number, if the entity has one
  registrationId: "TODO: company registration number",
  vatId: "DE815666847",
  contactEmail: "support@ouro.is",
};

// Single source of truth for jurisdiction copy on the legal pages.
export const GOVERNING_COUNTRY = DATA_CONTROLLER.country;

function isUnfilled(value) {
  return !value || String(value).trim().startsWith("TODO");
}

// True while a controller detail is still a TODO placeholder. The legal
// pages use this to avoid rendering placeholder text in production copy.
export function isControllerDetailUnfilled(value) {
  return isUnfilled(value);
}

export function formatControllerAddress(controller = DATA_CONTROLLER) {
  const locality = [controller.postalCode, controller.city]
    .filter((part) => part && !isUnfilled(part))
    .join(" ");
  return [controller.streetAddress, locality, controller.country]
    .filter((part) => part && !isUnfilled(part))
    .join(", ");
}

// Registration clause in parentheses, built only from filled values,
// e.g. "registration: HRB 12345, VAT ID: DE815666847".
export function formatControllerRegistration(controller = DATA_CONTROLLER) {
  const parts = [];
  if (!isUnfilled(controller.registrationId)) {
    parts.push(`registration: ${controller.registrationId}`);
  }
  if (!isUnfilled(controller.vatId)) {
    parts.push(`VAT ID: ${controller.vatId}`);
  }
  return parts.join(", ");
}
